module.exports = {"name":"Vyhľadávanie párov","icon":"<i class='material-icons'>people</i>","widget":[{"type":"couples-search","schemas":{"person-base":"urn:mbry:schema:1:APIpersons:v1","organization-base":"urn:mbry:schema:1:APIorganizations:v1"}}]}


//////////////////
// WEBPACK FOOTER
// ./src/blocks/couples-search/couples-search.json
// module id = 323
// module chunks = 0